import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["courseSelect", "expertiseAreaSelect"]

  loadExpertiseAreas(event) {
    const courseId = event.target.value
    
    if (!courseId) return

    fetch(`/teachers/help_requests/new?teacher_course=${courseId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.updateExpertiseAreaOptions(data.expertise_areas)
    })
    .catch(error => {
      console.error('Error loading expertise areas:', error)
    })
  }

  updateExpertiseAreaOptions(expertiseAreas) {
    const select = this.expertiseAreaSelectTarget
    
    // Clear existing options
    select.innerHTML = ''
    
    // Add default option
    const defaultOption = document.createElement('option')
    defaultOption.textContent = 'Session Type'
    select.appendChild(defaultOption)
    
    // Add expertise area options
    expertiseAreas.forEach(area => {
      const option = document.createElement('option')
      option.value = area.id
      option.textContent = area.name
      select.appendChild(option)
    })
  }
}
